import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGeneric = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 70,
	height: 48,
	viewBox: "0 0 70 48",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M0 6C0 2.68629 2.68629 0 6 0H64C67.3137 0 70 2.68629 70 6V42C70 45.3137 67.3137 48 64 48H6C2.68629 48 0 45.3137 0 42V6Z",
			fill: "#EFEDF5"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M24.3335 18.3327C24.3335 16.3076 25.9751 14.666 28.0002 14.666H42.0002C44.0252 14.666 45.6668 16.3076 45.6668 18.3327V29.666C45.6668 31.6911 44.0252 33.3327 42.0002 33.3327H28.0002C25.9751 33.3327 24.3335 31.6911 24.3335 29.666V18.3327ZM28.0002 16.666C27.0797 16.666 26.3335 17.4122 26.3335 18.3327V29.666C26.3335 30.5865 27.0797 31.3327 28.0002 31.3327H42.0002C42.9206 31.3327 43.6668 30.5865 43.6668 29.666V18.3327C43.6668 17.4122 42.9206 16.666 42.0002 16.666H28.0002Z",
			fill: "#46434F"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M24.6668 21.666C24.6668 21.1137 25.1145 20.666 25.6668 20.666H44.3335C44.8858 20.666 45.3335 21.1137 45.3335 21.666C45.3335 22.2183 44.8858 22.666 44.3335 22.666H25.6668C25.1145 22.666 24.6668 22.2183 24.6668 21.666Z",
			fill: "#46434F"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M28.3335 26.9993C28.3335 26.4471 28.7812 25.9993 29.3335 25.9993H32.6668C33.2191 25.9993 33.6668 26.4471 33.6668 26.9993C33.6668 27.5516 33.2191 27.9993 32.6668 27.9993H29.3335C28.7812 27.9993 28.3335 27.5516 28.3335 26.9993Z",
			fill: "#46434F"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M39.0002 26.9993C39.0002 26.4471 39.4479 25.9993 40.0002 25.9993H40.6668C41.2191 25.9993 41.6668 26.4471 41.6668 26.9993C41.6668 27.5516 41.2191 27.9993 40.6668 27.9993H40.0002C39.4479 27.9993 39.0002 27.5516 39.0002 26.9993Z",
			fill: "#46434F"
		})
	]
});
export default SvgGeneric;
